// router.js — SPA 路由器
// 路径匹配 → 动态 import chunk → DOM 注入 → CSS 切换 → 初始化
// esbuild splitting: true 下同一模块在所有 chunk 间共享同一实例

// ===== 路由表 =====
// 注意：官网首页已迁移至 /hello，站内所有指向 '/' 的导航都会被别名到 /hello
// （直接访问 https://lumeet.top/ 由服务端返回空白页，不加载本 SPA）
var ROUTES = {
  '/hello':     { chunk: function() { return import('../public/assets/js/esm/pages/index-entry.js'); }, chunkId: 'home', type: 'home' },
  '/home':      { chunk: function() { return import('../public/assets/js/esm/pages/list-entry.js'); }, chunkId: 'workspace', type: 'workspace', feature: 'home' },
  '/list':      { chunk: function() { return import('../public/assets/js/esm/pages/list-entry.js'); }, chunkId: 'workspace', type: 'workspace', feature: null },
  '/daily':     { chunk: function() { return import('../public/assets/js/esm/pages/list-entry.js'); }, chunkId: 'workspace', type: 'workspace', feature: 'diary' },
  '/todo':      { chunk: function() { return import('../public/assets/js/esm/pages/list-entry.js'); }, chunkId: 'workspace', type: 'workspace', feature: 'todo' },
  '/spark':     { chunk: function() { return import('../public/assets/js/esm/pages/list-entry.js'); }, chunkId: 'workspace', type: 'workspace', feature: 'inspiration' },
  '/music':     { chunk: function() { return import('../public/assets/js/esm/pages/list-entry.js'); }, chunkId: 'workspace', type: 'workspace', feature: 'music' },
  '/bill':      { chunk: function() { return import('../public/assets/js/esm/pages/list-entry.js'); }, chunkId: 'workspace', type: 'workspace', feature: 'bill' },
  '/project':   { chunk: function() { return import('../public/assets/js/esm/pages/list-entry.js'); }, chunkId: 'workspace', type: 'workspace', feature: 'project' },
  '/home-m':    { chunk: function() { return import('../public/assets/js/esm/pages/list-m-entry.js'); }, chunkId: 'workspace-m', type: 'workspace', feature: 'home', css: 'mobile' },
  '/list-m':    { chunk: function() { return import('../public/assets/js/esm/pages/list-m-entry.js'); }, chunkId: 'workspace-m', type: 'workspace', feature: null, css: 'mobile' },
  '/daily-m':   { chunk: function() { return import('../public/assets/js/esm/pages/list-m-entry.js'); }, chunkId: 'workspace-m', type: 'workspace', feature: 'diary', css: 'mobile' },
  '/todo-m':    { chunk: function() { return import('../public/assets/js/esm/pages/list-m-entry.js'); }, chunkId: 'workspace-m', type: 'workspace', feature: 'todo', css: 'mobile' },
  '/spark-m':   { chunk: function() { return import('../public/assets/js/esm/pages/list-m-entry.js'); }, chunkId: 'workspace-m', type: 'workspace', feature: 'inspiration', css: 'mobile' },
  '/music-m':   { chunk: function() { return import('../public/assets/js/esm/pages/list-m-entry.js'); }, chunkId: 'workspace-m', type: 'workspace', feature: 'music', css: 'mobile' },
  '/bill-m':    { chunk: function() { return import('../public/assets/js/esm/pages/list-m-entry.js'); }, chunkId: 'workspace-m', type: 'workspace', feature: 'bill', css: 'mobile' },
  '/project-m': { chunk: function() { return import('../public/assets/js/esm/pages/list-m-entry.js'); }, chunkId: 'workspace-m', type: 'workspace', feature: 'project', css: 'mobile' },
};

// ===== 内部状态 =====
var _currentDestroy = null;
var _currentSwitchFeature = null;
var _currentRoute = null;
var _currentRouteKey = null;
var _scrollMap = {};
var _loading = false;

// ===== 公开 API =====

export function navigate(url) {
  if (!url) return;
  if (url.charAt(0) === '#') return;
  if (url && (url.indexOf('http') === 0 || url.indexOf('.html') !== -1)) {
    window.location.href = url;
    return;
  }

  var clean = (url || '').replace(/\/$/, '') || '/';
  // 站内导航到 '/' 时别名落到 /hello（replaceState，不产生跳转/新历史记录）
  var isHomeAlias = clean === '/';
  if (isHomeAlias) clean = '/hello';
  var route = matchRoute(clean);

  // 平台自动识别：workspace 路由根据屏幕宽度自动加/去 -m 后缀
  if (route && route.type === 'workspace') {
    var isMobile = window.matchMedia('(max-width: 1024px)').matches;
    if (isMobile && !clean.endsWith('-m')) {
      clean = clean + '-m';
    } else if (!isMobile && clean.endsWith('-m')) {
      clean = clean.replace(/-m$/, '');
    }
    route = matchRoute(clean);
  }

  history[isHomeAlias ? 'replaceState' : 'pushState'](null, '', clean);
  if (route) {
    loadRoute(route);
  } else {
    render404();
  }
}

export function matchRoute(pathname) {
  var clean = (pathname || location.pathname).replace(/\/$/, '') || '/';
  return ROUTES[clean] || null;
}

export function loadRoute(route) {
  if (_loading) return;

  // 1. 清理 body class
  document.body.classList.remove('preview-mode', 'sidebar-expanded', 'mobile-secondary-open');

  // 2. 判断 chunk 是否变化
  var sameChunk = _currentRoute && route.chunkId === _currentRoute.chunkId;

  if (sameChunk && _currentSwitchFeature) {
    if (_currentRouteKey) {
      _scrollMap[_currentRouteKey] = window.scrollY;
    }
    _currentRouteKey = route.chunkId + (route.feature ? ':' + route.feature : '');
    _currentRoute = route;
    var sw = _currentSwitchFeature(route.feature, route);
    if (sw && typeof sw.catch === 'function') sw.catch(function(e) { console.error('[Router] switchFeature 失败:', e); });
    document.title = getPageTitle(route);
    window.scrollTo(0, _scrollMap[_currentRouteKey] || 0);
    return;
  }

  // 3. 保存旧路由滚动位置（在 destroy 之前）
  if (_currentRouteKey) {
    _scrollMap[_currentRouteKey] = window.scrollY;
  }

  // 4. 销毁旧页面
  if (_currentDestroy) {
    try { _currentDestroy(); } catch (e) { console.error('[Router] destroy 失败:', e); }
    _currentDestroy = null;
    _currentSwitchFeature = null;
  }

  // 5. 切换路由专属 CSS（在 DOM 注入前启动 CSS 下载，与 DOM 注入并行，减少 FOUC）
  loadRouteCSS(route);

  // 6. 清理旧 DOM + 注入新 DOM 骨架
  var root = document.getElementById('app-root');
  if (root) {
    // 注意：injectDOMSkeleton 内部已执行内容替换，无需预清空
    injectDOMSkeleton(route, root);
  }

  // 7. 更新标题
  document.title = getPageTitle(route);

  // 8. 记录新路由 key
  var routeKey = route.chunkId + (route.feature ? ':' + route.feature : '');
  _currentRouteKey = routeKey;

  // 9. 动态 import chunk + 初始化
  _loading = true;
  route.chunk().then(function(mod) {
    try {
      if (mod.initApp) {
        var initResult = mod.initApp(route.feature);
        if (initResult && initResult.then) {
          initResult.then(function() {
            window.scrollTo(0, _scrollMap[routeKey] || 0);
            finishLoad(mod, routeKey);
          }).catch(function(e) {
            console.error('[Router] initApp (async) 失败:', e);
            handleInitError(root);
          });
          return;
        }
      }
      window.scrollTo(0, _scrollMap[routeKey] || 0);
      finishLoad(mod, routeKey);
    } catch (e) {
      console.error('[Router] initApp 失败:', e);
      handleInitError(root);
    }
  }).catch(function(err) {
    console.error('[Router] chunk 加载失败:', err);
    if (root) {
      root.innerHTML =
        '<div style="text-align:center;padding:80px 20px;">' +
        '<p>页面加载失败，请检查网络连接后</p>' +
        '<button onclick="location.reload()" style="padding:8px 20px;border:1px solid #ddd;border-radius:6px;background:#fff;cursor:pointer;">刷新页面</button>' +
        '</div>';
    }
    _loading = false;
  });
}

// ===== 内部函数 =====

function finishLoad(mod, routeKey) {
  _currentDestroy = mod.destroyApp || null;
  if (mod.switchFeature) {
    _currentSwitchFeature = mod.switchFeature;
  }
  _loading = false;
}

function handleInitError(root) {
  if (root) {
    root.innerHTML =
      '<div style="text-align:center;padding:80px 20px;">' +
      '<p>页面初始化失败</p>' +
      '<button onclick="location.reload()" style="padding:8px 20px;border:1px solid #ddd;border-radius:6px;background:#fff;cursor:pointer;">刷新页面</button>' +
      '</div>';
  }
  _loading = false;
}

function injectDOMSkeleton(route, root) {
  if (route.type === 'workspace') {
    // SSR 检测：如果 #app-root 中已有 workspace 容器（SSR 直出），跳过模板克隆
    var existing = root.querySelector('.mobile-view-container, .desktop-container');
    if (existing) {
      // SSR 已存在 → 设置 data-workspace 标记（不克隆 template）
      existing.setAttribute('data-workspace', '');
    } else {
      var isDesktop = window.matchMedia('(min-width: 1025px)').matches;
      var tplId = isDesktop ? 'desktop-tpl' : 'mobile-tpl';
      var tpl = document.getElementById(tplId);
      if (tpl && root) {
        root.replaceChildren(tpl.content.cloneNode(true));
        // 标记根元素，供 resize 断点检测精确识别 workspace 路由
        if (root.firstElementChild) root.firstElementChild.setAttribute('data-workspace', '');
      }
    }
    // 不 return — 让执行流自然落到末尾的底部栏/FAB 显示逻辑
  } else if (route.type === 'home') {
    var homeTpl = document.getElementById('home-tpl');
    if (homeTpl) {
      root.innerHTML = homeTpl.innerHTML;
    }
  }

  // 控制移动端底部栏 + 二级工具栏：仅 workspace 路由 + 手机端显示，其余隐藏
  var bottomBar = document.getElementById('mobileBottomWrapper');
  var secondaryBar = document.getElementById('mobileSecondaryToolbar');
  if (bottomBar || secondaryBar) {
    var show = route.type === 'workspace' && !window.matchMedia('(min-width: 1025px)').matches;
    if (bottomBar) bottomBar.style.display = show ? '' : 'none';
    // 二级工具栏保持默认收起（隐藏状态由 view-nav-mobile 委托管理）
    if (secondaryBar) secondaryBar.style.display = show ? '' : 'none';
  }
}

function getPageTitle(route) {
  var titles = {
    '/hello': 'LuMeet',
    '/home': '首页 - LuMeet', '/home-m': '首页 - LuMeet',
    '/list': '工具台 - LuMeet', '/list-m': '工具台 - LuMeet',
    '/daily': '日记 - LuMeet', '/daily-m': '日记 - LuMeet',
    '/todo': '待办 - LuMeet', '/todo-m': '待办 - LuMeet',
    '/spark': '灵感 - LuMeet', '/spark-m': '灵感 - LuMeet',
    '/music': '音乐 - LuMeet', '/music-m': '音乐 - LuMeet',
    '/bill': '记账 - LuMeet', '/bill-m': '记账 - LuMeet',
    '/project': '项目 - LuMeet', '/project-m': '项目 - LuMeet',
  };
  for (var path in ROUTES) {
    var r = ROUTES[path];
    if (r.chunkId === route.chunkId && r.feature === route.feature && r.type === route.type) {
      return titles[path] || 'LuMeet';
    }
  }
  return 'LuMeet';
}

function render404() {
  document.title = '404 - LuMeet';
  var root = document.getElementById('app-root');
  if (root) {
    root.innerHTML =
      '<div style="text-align:center;padding:120px 20px;">' +
      '<h1 style="font-size:72px;color:#ddd;margin:0;">404</h1>' +
      '<p style="font-size:16px;color:#888;margin:16px 0;">页面不存在</p>' +
      '<a href="/hello" data-spa-link style="color:#F688C2;">返回首页</a>' +
      '</div>';
  }
}

// ===== CSS 动态管理 =====

export function loadRouteCSS(route) {
  var cssFiles = getCSSFilesForRoute(route);
  if (!cssFiles) {
    var oldLinks = document.querySelectorAll('[data-route-css]');
    for (var i = 0; i < oldLinks.length; i++) { oldLinks[i].remove(); }
    return;
  }

  // 检测当前已加载的 CSS 是否与即将加载的完全相同（避免 SSR 首屏时移除→重载导致闪烁）
  var oldLinks = document.querySelectorAll('[data-route-css]');
  if (oldLinks.length === cssFiles.length) {
    var same = true;
    for (var j = 0; j < oldLinks.length; j++) {
      if (oldLinks[j].getAttribute('href') !== cssFiles[j].href) { same = false; break; }
    }
    if (same) return;
  }

  // 移除旧 CSS
  for (var k = 0; k < oldLinks.length; k++) { oldLinks[k].remove(); }

  // 创建新 CSS 链接
  for (var l = 0; l < cssFiles.length; l++) {
    var item = cssFiles[l];
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = item.href;
    if (item.media) link.media = item.media;
    link.setAttribute('data-route-css', '');
    document.head.appendChild(link);
  }
}

function getCSSFilesForRoute(route) {
  if (route.type === 'home') {
    return [{ href: '/assets/css/index.css' }];
  }
  if (route.type === 'workspace') {
    // ?v= 版本串：由服务端注入 window.__ASSET_VERSION__（config/asset-versions.js 单一来源），
    // 与 list.html / list-m.html 直出保持一致，绕开 SW 旧缓存
    var v = (typeof window !== 'undefined' && window.__ASSET_VERSION__) ? '?v=' + window.__ASSET_VERSION__ : '';
    // 按 platform 只加载对应 CSS，不再同时加载 desktop.css + mobile.css
    if (route.css === 'mobile') {
      return [{ href: '/assets/css/base.css' + v }, { href: '/assets/css/mobile.css' + v }];
    }
    return [{ href: '/assets/css/base.css' + v }, { href: '/assets/css/desktop.css' + v }];
  }
  return null;
}

// ===== popstate 处理 =====
window.addEventListener('popstate', function() {
  var route = matchRoute(location.pathname);
  if (route) { loadRoute(route); } else { render404(); }
});

// 暴露 navigate 和 loadRouteCSS 给各 chunk 使用
window.__spaNavigate = navigate;
window.__spaLoadRouteCSS = loadRouteCSS;

// ===== 全局点击委托：data-spa-link 的 SPA 内导航 =====
document.addEventListener('click', function(e) {
  var target = e.target;
  while (target && target !== document) {
    if (target.tagName === 'A' && target.getAttribute('data-spa-link') !== null) {
      e.preventDefault();
      navigate(target.getAttribute('href'));
      return;
    }
    target = target.parentNode;
  }
});
